var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaiEth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1161_14648",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V26.1528H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1161_14648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0764 25.8339C20.125 25.8339 25.8339 20.125 25.8339 13.0764C25.8339 6.02794 20.125 0.31897 13.0764 0.31897C6.02794 0.31897 0.31897 6.02794 0.31897 13.0764C0.31897 20.125 6.02794 25.8339 13.0764 25.8339Z",
    fill: "#F4B731"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31427 6.69775H12.5448C15.7236 6.69775 18.1262 8.38812 19.0299 10.8439H20.6565V12.3323H19.3701C19.3913 12.5662 19.4126 12.8107 19.4126 13.0446V13.0765C19.4126 13.3529 19.3913 13.6187 19.3701 13.8845H20.6671V15.3622H19.0086C18.0731 17.7861 15.681 19.4552 12.5448 19.4552H7.31427V15.3622H5.50696V13.8845H7.3249V12.3217H5.50696V10.8333H7.3249V6.69775H7.31427ZM8.78138 15.3622V18.1263H12.5448C14.8731 18.1263 16.5953 17.0207 17.3927 15.3622H8.78138ZM17.8392 13.8845H8.78138V12.3217H17.8498C17.8817 12.5662 17.903 12.8213 17.903 13.0765V13.1084C17.8923 13.3742 17.8711 13.6293 17.8392 13.8845ZM12.5448 8.02666C14.8731 8.02666 16.606 9.1642 17.4033 10.8439H8.78138V8.02666H12.5448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 20.5182C28.6724 20.5182 32 17.1907 32 13.0764C32 8.9621 28.6724 5.63452 24.5581 5.63452C20.4438 5.63452 17.1163 8.9621 17.1163 13.0764C17.1163 17.1907 20.4438 20.5182 24.5581 20.5182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5582 20.1993C28.4917 20.1993 31.6811 17.01 31.6811 13.0764C31.6811 9.14286 28.4917 5.95349 24.5582 5.95349C20.6246 5.95349 17.4352 9.14286 17.4352 13.0764C17.4352 17.01 20.6246 20.1993 24.5582 20.1993Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 7.73962V11.6838L27.8963 13.1722L24.5581 7.73962Z",
    fill: "#C1CCF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 7.73962L21.2199 13.1828L24.5581 11.6944V7.73962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 15.7342V18.4133L27.8963 13.7887L24.5581 15.7342Z",
    fill: "#C1CCF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 18.4133V15.7342L21.2199 13.7993L24.5581 18.4133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M24.5581 15.1176L27.8963 13.1827L24.5581 11.6943V15.1176Z",
    fill: "#8198EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2199 13.1721L24.5581 15.107V11.6837L21.2199 13.1721Z",
    fill: "#C1CCF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiEth);
export default __webpack_public_path__ + "static/media/dai_eth.c8eb4e89ad52c5c030aea9f420075351.svg";
export { ForwardRef as ReactComponent };